import { rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import pKullaniciKontrol from '../../../../api/models/pKullaniciKontrol';

export const action_api_set_input = (
  body: pKullaniciKontrol | null | undefined
): IInputAction<pKullaniciKontrol> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_KULLANICIKONTROL, true, body);

export const action_async_start = (body: pKullaniciKontrol): IPromiseAction<pKullaniciKontrol> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_KULLANICIKONTROL,
    new Api.User.KullaniciKontrol().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<boolean> | null | undefined,
  error: IError | null | undefined
): IApiAction<boolean> =>
  ActionFunctions.action_async_complete_api<boolean>(
    ActionSubTypes.API_KULLANICIKONTROL,
    data?.Value,
    error
  );
